export const VIEWER_INFO = 'VIEWER_INFO';
export const VIEWER_ERROR = 'VIEWER_ERROR';
export const VIEWER_FETCHING = 'VIEWER_FETCHING';

export const PROPOSAL_SAVED = 'PROPOSAL_SAVED';
export const PROPOSAL_CLEAR = 'PROPOSAL_CLEAR';
export const PROPOSAL_CREATED = 'PROPOSAL_CREATED';
export const PROPOSAL_RETRIEVED = 'PROPOSAL_RETRIEVED';
export const PROPOSAL_ERROR = 'PROPOSAL_ERROR';
export const PROPOSAL_BUSY = 'PROPOSAL_BUSY';
export const PROPOSAL_DELETED = 'PROPOSAL_DELETED';
export const PROPOSAL_LIST_RETRIEVED = 'PROPOSAL_LIST_RETRIEVED';
export const TIL_BEHANDLING_STATUS = 'TIL_BEHANDLING_STATUS';
export const COST_CENTRE_BUSY = 'COST_CENTRE_BUSY';
export const COST_CENTRE_RETRIEVED = 'COST_CENTRE_RETRIEVED';
export const COST_CENTRE_ERROR = 'COST_CENTRE_ERROR';
export const PROPOSAL_FILE_ADDED = 'PROPOSAL_FILES_ADDED';
export const PROPOSAL_FILE_DELETE = 'PROPOSAL_FILE_DELETE';

export const PEOPLE_PICKER_ERROR = 'PEOPLE_PICKER_ERROR';
export const IT_CONTACT_FINISHED = 'IT_CONTACT_FINISHED';
export const CLIENT_CONTACT_FINISHED = 'CLIENT_CONTACT_FINISHED';
export const RESPONSIBLE_FINISHED = 'RESPONSIBLE_FINISHED';
export const PEOPLE_PICKER_BUSY = 'PEOPLE_PICKER_BUSY';

export const EMAIL_ERROR = 'EMAIL_ERROR';

export const FIELD_OPTION = 'PROPOSAL_FIELD_OPTION';
export const FIELD_OPTION_ERROR = 'PROPOSAL_FIELD_OPTION_ERROR';



// WEBPACK FOOTER //
// ./src/constants/actions.js